import React from "react";

import { getStaticUrl } from "js/config";

const logo = getStaticUrl("/images/beautifulai-logos/beautifulai-logo-reverse.svg");

export default function BeautifulLogo({ forceMarketing, noLink }) {
    let href = forceMarketing ? "/?" : "/";
    if (noLink) {
        href = undefined;
    }
    return (
        <a href={href}>
            <img
                alt="Beautiful.ai"
                src={logo}
                width={200}
            />
        </a>
    );
}
